module.exports = __webpack_public_path__ + "static/media/seguridad.38c9a292.svg";